import { cn } from "@newxsystems/shared";
import { GroundAction } from "../GroundAction/GroundAction";
import { GroundMedia } from "../GroundMedia/GroundMedia";
import { GroundRichText } from "../GroundRichText/GroundRichText";
import type { ICallToActionSplitProps } from "./CallToActionSplit.props";

const widths = { small: "md:w-2/3", medium: "md:w-5/6", large: "md:w-full" } as const;

export const CallToActionSplit = ({
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionSplitProps) => (
  <div className="grid grid-cols-1 items-center gap-7 md:grid-cols-2 md:gap-12">
    {eyebrow ? (
      <p className="order-1 border-b border-mineral-gray/40 pb-2 font-ground-mono text-xs md:col-start-1">
        {eyebrow}
      </p>
    ) : null}
    {image ? (
      <GroundMedia
        aspectRatio={image.aspectRatio || "16:9"}
        className={cn(
          "order-2 w-full justify-self-end md:col-start-2 md:row-span-4 md:row-start-1",
          widths[imageWidth || "medium"],
        )}
        media={image.image}
        sizes="(min-width: 768px) 50vw, 100vw"
      />
    ) : null}
    {heading ? (
      <h2 className="order-3 font-ground-display text-[clamp(1.875rem,9vw,3.75rem)] font-bold leading-[0.98] tracking-[-0.025em] text-balance [overflow-wrap:normal] [word-break:normal] hyphens-none md:col-start-1">
        {heading}
      </h2>
    ) : null}
    {description ? (
      <GroundRichText
        className="order-4 max-w-[65ch] text-mineral-gray md:col-start-1"
        content={description}
      />
    ) : null}
    {buttons?.length ? (
      <div
        className={cn(
          "order-5 flex flex-wrap gap-3",
          image
            ? "md:col-start-1"
            : "md:col-start-2 md:row-span-3 md:row-start-1 md:justify-self-end",
        )}
      >
        {buttons.map((button, index) => (
          <GroundAction
            action={button}
            className="border-mineral-gray text-mineral-gray"
            key={`${button.href}-${index}`}
          />
        ))}
      </div>
    ) : null}
  </div>
);

CallToActionSplit.displayName = "Content::CallToActionSplit";
